import React, { useEffect, useState } from "react";
import { UpOutlined } from "@ant-design/icons";
import "./ExpandableBox.scss";

const ExpandableBox = (props) => {
  const { closable = true } = props;

  const [className, setClassName] = useState(
    props.className ? props.className.split(" ") : []
  );

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    isOpen
      ? setClassName([...className, "is-expanded"])
      : setClassName((className) =>
          className.filter((item) => item !== "is-expanded")
        );
    // eslint-disable-next-line
  }, [isOpen]);

  const handleExpanding = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`expandable-box ${className.join(" ")}`}>
      {props.children && props.children}
      {(closable || (!closable && !isOpen)) && (
        <UpOutlined
          onClick={handleExpanding}
          className={`expand ${isOpen ? "open" : "close"}`}
        />
      )}
    </div>
  );
};

export default ExpandableBox;
